export default class HeaderImage {
  image: { dev: string; uat: string; qa: string; prod: string }
  version: string

  constructor(image: { dev: string; uat: string; qa: string; prod: string }, version: string) {
    this.image = image
    this.version = version
  }

  getByEnvironment(): string {
    if (this.version.toUpperCase().includes('DEVELOP')) {
      return this.image.dev
    }

    if (this.version.toUpperCase().includes('UAT')) {
      return this.image.uat
    }

    if (this.version.toUpperCase().includes('QA')) {
      return this.image.qa
    }

    return this.image.prod
  }
}
